import { Component, OnInit, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { Subject, Subscription, Observable } from 'rxjs';

import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { FormControlService } from 'src/app/shared/services/form-control.service';
import { VentaService, EntradasService } from '../venta';
import { ConfigurationService, TurnoService } from 'src/app/core';
import { takeWhile, map, take, debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { Localizador } from './models/localizador.model';
import { PagerService } from 'src/app/shared/services/pager.service';
import { ModalService } from 'src/app/shared/services/modal.service';
import { Router } from '@angular/router';
import { MotivosService } from '../venta/services/motivos.service';
import { TranslateService } from '../../shared/services/translate.service';
import { AppConfiguration } from 'src/app/app.configuration';
import { HttpClient } from '@angular/common/http';
import { VentaPausadaService } from './services/venta-pausada.service';
import { DialogSalePauseDetailComponent, DialogSalePauseDetailData, DialogSalePauseDetailResult } from '../venta/dialogs/dialog-sale-pause-detail/dialog-sale-pause-detail.component';
import { MatDialog } from '@angular/material/dialog';
import { VentaPausadaGet } from './interfaces/gestionar-pausadas.interface';

@Component({
  selector: 'ticketing-localizador',
  templateUrl: './gestionar-pausadas.component.html',
  styleUrls: ['./gestionar-pausadas.component.scss'],
  // tslint:disable-next-line:use-host-property-decorator
  host: {
    class: 'layout'
  }
})
export class GestionarPausadasComponent implements OnInit, OnDestroy {
  idioma = 'es-Es';
  reservas;

  ventaPausadaForm: FormGroup;
  myFormSub: Subscription;

  localizador: Localizador;
  localizador$: Observable<Localizador>;
  localizadores$: Observable<any>;
  filtrarCentro: Boolean;

  private alive = true;

  @ViewChild('identificadorInput', { static: true }) identificadorInput: ElementRef;
  @ViewChild('tpvInput', { static: true }) tpvInput: ElementRef;
  @ViewChild('usuarioInput', { static: true }) usuarioInput: ElementRef;
  @ViewChild('tagInput', { static: true }) tagInput: ElementRef;

  pager: any = {};
  pagedItems: any[];
  sePuedeAceptar: boolean;
  sePuedeImprimir: boolean;
  sePuedeFinalizar: boolean;
  items: any[];
  itemsConMotivo: any[];
  reserva: any;
  loading = false;

  constructor(
    public ventaPausadaService: VentaPausadaService,
    private pagerService: PagerService,
    private formBuilder: FormBuilder,
    private formControlService: FormControlService,
    private modalService: ModalService,
    private configurationService: ConfigurationService,
    private router: Router,
    private entradaService: EntradasService,
    private ventaService: VentaService,
    private motivoService: MotivosService,
    private translate: TranslateService,
    private turnoService: TurnoService,
    private config: AppConfiguration,
    private http: HttpClient,
    public dialog: MatDialog,
  ) {

    this.ventaPausadaForm = this.formBuilder.group({
      tpvId: ["", Validators.required],
      tag: [""],
      identificador: [""],
      usuarioId: ["", Validators.required],
      filtrarCentro: this.filtrarCentro
    });

    //Verificar check "Enviar mail"
    const conexionId = JSON.parse(localStorage.getItem('conexionId'));    
    const body = {
      ConexionIacpos: conexionId,
      CodigoApp: this.config.getConfig('CODIGO_APLICACION'),
      CodigoModulo: '',
      Id: this.configurationService.datosTPVPathValue.pkId 
    };

    this.http
      .post(
        `${this.config.getConfig('API_URL')}api/Configuracion/GetAppConfig`,
        body
      )
      .subscribe((res: any) => {          
        const configApp = (res && res.DatosResult) ? res.DatosResult : undefined;
        if(configApp) {
          this.configurationService.setDeviceConfiguration(res.DatosResult);    
        }
      }); 

  }

  openModal(id: string) {
    this.modalService.open(id);
  }

  ngOnInit() {
    this.localizador$ = this.ventaPausadaService.localizador;
    this.localizadores$ = this.ventaPausadaService.localizadores;
    this.filtrarCentro = this.configurationService.appConfig.value.DatosResult.AppConfigJsonLocalizador.FiltrarCentro && this.configurationService.appConfig.value.DatosResult.AppConfigJsonLocalizador.FiltrarCentro > 0 ? true : false;

    this.onChangesV2();

    this.fillFormActualUser(this.filtrarCentro);

    this.configurationService.datosInicio
      .pipe(takeWhile(() => this.alive))
      .subscribe(conf => (this.idioma = conf.Idioma));

    /* this.ventaPausadaService.queryLocalizador$
      .pipe(takeWhile(() => this.alive))
      .subscribe(localizador => {
        if (localizador) {
          this.localizadorForm.controls['localizador'].patchValue(localizador);
        } else {
          this.localizadorForm.controls['localizador'].patchValue('');
        }
      }); */

  }

  fillFormActualUser(filtrarCentro: Boolean) {
    console.log({
      usuarioId: this.turnoService.turnoValue,
      tpvId: this.configurationService.datosTPVPathValue.pkId
    })
    this.ventaPausadaForm.controls['usuarioId'].patchValue(this.turnoService.turnoValue.UsuarioId || "");
    this.ventaPausadaForm.controls['tpvId'].patchValue(this.configurationService.datosTPVPathValue.pkId || "");
    this.ventaPausadaForm.controls['filtrarCentro'].patchValue(filtrarCentro);
  }

  ngOnDestroy() {
    this.alive = false;
    if (this.myFormSub) {
      this.myFormSub.unsubscribe();
    }
  }


  /* onChanges() {
    this.myFormSub = this.ventaPausadaService
      .buscar(this.ventaPausadaForm.valueChanges, this.ventaPausadaForm)
      .pipe(takeWhile(() => this.alive))
      .subscribe(reservas => {
        this.reservas = reservas;
        this.setPage(1);
      });
  } */

  onChangesV2() {
    this.myFormSub = this.ventaPausadaForm.valueChanges
      .pipe(takeWhile(() => this.alive))
      .pipe(debounceTime(400))
      .pipe(distinctUntilChanged())
      .subscribe(() => {

        console.log({
          isValid: this.ventaPausadaForm.valid,
          formValue: this.ventaPausadaForm.value
        })

        if (this.ventaPausadaForm.valid) {
          this.ventaPausadaService
            .buscarVentasPausadas(this.ventaPausadaForm.value)
            .pipe(take(1))
            .subscribe(reservas => {
              this.reservas = reservas;
              this.setPage(1);
            });
        }
      });
  }


  openDialogSalePauseDetail(reserva: VentaPausadaGet) {
      const dialogRef = this.dialog.open<DialogSalePauseDetailComponent, DialogSalePauseDetailData> (DialogSalePauseDetailComponent, {
        data: {
          ventapausada: reserva
        },
        disableClose: true,
      });
  
      dialogRef.afterClosed().subscribe((result: DialogSalePauseDetailResult) => {
        if (!result.confirm) {
          return;
        }
  
        console.log({
          result
        })
  
        // this.llamarPeticionPausarVenta(result.tag);
      });
    }

  setPage(page: number) {
    this.pager = this.pagerService.getPager(this.reservas.length, page, 6);
    this.pagedItems = this.reservas.slice(this.pager.startIndex, this.pager.endIndex + 1);

    this.pager.pages = this.pager.pages.filter(num => num <= this.pager.totalPages);

    while (this.pager.pages.length < 6 && this.pager.pages[0] > 1) {
      this.pager.pages.unshift(this.pager.pages[0] - 1);
    }
  }

  focusValue(event: Event, inputRef: ElementRef) {
    this.formControlService.setCurrentFormGroup(
      this.ventaPausadaForm,
      inputRef.nativeElement,
      (<HTMLElement>event.target).getAttribute('category')
    );
  }

  checkStatus(status: string) {
    switch (status) {
      case '00':
        return this.translate.instant('ANULADA');
      case '01':
        return this.translate.instant('PAGADA');
      case '02':
        return this.translate.instant('PENDIENTE');
      case '03':
        return this.translate.instant('VENCIDA');
      case '04':
        return this.translate.instant('CANJEADA');
      case '05':
        return this.translate.instant('DEVUELTA');
      case '06':
        return this.translate.instant('DEVUELTA_PARCIALMENTE');
      default:
        return this.translate.instant('PENDIENTE');
    }
  }

  checkStatusColor(status: string) {
    switch (status) {
      case '00':
        return 'anulada';
      case '01':
        return 'pagada';
      case '02':
        return 'pendiente';
      case '03':
        return 'vencida';
      case '04':
        return 'canjeada';
      case '05':
        return 'devuelta';
      case '06':
        return 'devolucionParcial';
      default:
        return 'pendiente';
    }
  }

  seleccionarReserva(reserva) {
    this.reserva = reserva;
  }

  private async cargarDatosLocalizador(reserva) {
    this.ventaService.clearCarrito();
    const entradas = await this.mapEntradas(reserva);
    entradas.forEach(entrada => {
      this.ventaService.sendEntradas(entrada.entrada, entrada.cantidad);
    });
    const cliente = this.mapCliente(reserva);
    this.ventaService.setClienteSeleccionadoValue(cliente);
  }

  mapCliente(reserva) {
    return reserva.ReservaCliente[0];
  }

  agregarMotivos(reserva) {
    if (this.itemsConMotivo.length !== 0) {
      this.motivoService.setEntradasDesdeLocalizadorConMotivo(this.itemsConMotivo);
      // TODO: arreglar esto, peta con los localizadores que tengan entradas con motivo
      this.openModal('motivosLocalizador');
      this.modalService.open('motivosLocalizador');
    }
  }

  async mapEntradas(reserva): Promise<any[]> {

    const entradas: any = reserva.ReservaItems.map(producto => {

      const entrada = {
        ...JSON.parse(JSON.stringify(producto)),
        noEditable: reserva.Pagada === '1' ? true : false,
        TipoEntradaId: producto.ItemId,
        TipoPromocionId: '',
        TipoAbonadoId: '',
        Minimo: '',
        Maximo: '',
        Orden: '',
        PrecioEnDivisaReferencia: producto.PrecioUnidad
      };
      entrada.IVA = producto.IVA.replace(',', '.');
      entrada.Comision = this.conversor(producto.Comision);
      entrada.Fecha = producto.FechaHoraEntrada;
      entrada.precioFinalVenta = this.conversor(producto.PrecioUnidad);

      return { entrada: entrada, cantidad: Number.parseInt(producto.Cantidad, 10) };
    });
    const entradasIds = entradas.map(e => e.entrada.TipoEntradaId).join(',');

    return await this.entradaService
      .getRecintosEntrada(entradasIds)
      .pipe(
        map(() => {
          entradas.forEach(e => {
            if (e.entrada) {
              e.entrada.recintos = [];
            }
          });
          return entradas;
        })
      )
      .toPromise();
  }


  conversor(precio: string) {
    return Number.parseFloat(precio.replace(/,/, '.'));
  }

  selectedReservaClass(reserva) {
    if (reserva === this.reserva) {
      return 'selected';
    } else {
      return 'unselected';
    }
  }

  isReservaSelected() {
    if (this.reserva) {
      return false;
    } else {
      return true;
    }
  }

  changefiltrarCentro() {
    this.filtrarCentro = !this.filtrarCentro;
  }

  mostrarFiltro() {
    return this.configurationService.appConfig.value.DatosResult.AppConfigJsonLocalizador.FiltrarCentro &&
      this.configurationService.appConfig.value.DatosResult.AppConfigJsonLocalizador.FiltrarCentro == 2;
  }
}
